var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"to":{name: 'orders'},"block":""}},[_vm._v(" "+_vm._s(_vm.$t('orders'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }